import { ContragentType } from "../enums/contragentType";
import { AddCompanyDto } from "./addCompanyDto";

export interface AddCompanyFormDto {
    name: string;
    type: ContragentType;
    address: string;
    responsibleFio: string;
    inn: string;
    phone: string;
    ogrn?: string;
    isTelemed: boolean,
}

export const mapToAddCompanyDto = (formData: AddCompanyFormDto): AddCompanyDto => {
    return {
        name: formData.name,
        type: formData.type,
        address: formData.address,
        responsibleFio: formData.responsibleFio,
        inn: formData.inn,
        phone: formData.phone,
        ogrn: formData.type === ContragentType.SelfEmployed ? undefined : formData.ogrn,
        isTelemed: formData.isTelemed,
    }
};
